import { getCreationInput } from "../misc/helperfuncs";

const boxTypeInputs = (newBoxType) => {
  return [
    getCreationInput(
      "input",
      "Name",
      "plural",
      "Choose a short fitting name for your box type like  `tasks` or `events`",
      true,
      {
        maxLength: 20,
        minLength: 4,
        value: newBoxType?.names.plural,
        inputType: "text",
        fixed: false,
        allowSpaces: false,
        fields: ["names", "plural"],
      },
      "string"
    ),
    getCreationInput(
      "input",
      "Singular",
      "singular",
      "What is a single box called? tasks -> task, difficulties -> difficulty",
      true,
      {
        fields: ["names", "singular"],
        maxLength: 20,
        minLength: 4,
        value: newBoxType?.names.singular,
        inputType: "text",
        fixed: false,
        allowSpaces: false,
      },
      "string"
    ),
    getCreationInput(
      "image",
      "Icon",
      "icon",
      "Choose an icon for your box type",
      true,
      {
        image: newBoxType?.icon,
      }
    ),
    getCreationInput(
      "colors",
      "Colors",
      "color",
      "Choose a primary and secondary color for your box",
      true,
      {},
      "string"
    ),
    getCreationInput(
      "ratingInput",
      "First General Rating",
      "ratings",
      "Choose the first general rating for this box type",
      true,
      {
        field: ["general", "first", "general"],
        name: newBoxType.ratings.general.first.general.name,
        hint: newBoxType.ratings.general.first.general.hint,
        icon: newBoxType.ratings.general.first.general.icon,
        personal: {
          name: newBoxType.ratings.general.first.personal.name,
          hint: newBoxType.ratings.general.first.personal.hint,
        },
      }
    ),
    getCreationInput(
      "ratingInput",
      "Second General Rating",
      "ratings",
      "Choose the second general rating for this box Type",
      true,
      {
        field: ["general", "second", "general"],
        name: newBoxType.ratings.general.second.general.name,
        hint: newBoxType.ratings.general.second.general.hint,
        icon: newBoxType.ratings.general.second.general.icon,
        personal: {
          field: ["general", "second", "personal"],
          name: newBoxType.ratings.general.second.personal.name,
          hint: newBoxType.ratings.general.second.personal.hint,
        },
      }
    ),
    getCreationInput(
      "ratingInput",
      "First Active Rating",
      "ratings",
      "Choose the first rating for while the box is in active",
      true,
      {
        field: ["active", "first"],
        name: newBoxType.ratings.active.first.name,
        hint: newBoxType.ratings.active.first.hint,
        icon: newBoxType.ratings.active.first.icon,
      }
    ),
    getCreationInput(
      "ratingInput",
      "Second Active Rating",
      "ratings",
      "Choose the second rating for while the box is in active",
      true,
      {
        field: ["active", "second"],
        name: newBoxType.ratings.active.second.name,
        hint: newBoxType.ratings.active.second.hint,
        icon: newBoxType.ratings.active.second.icon,
      }
    ),
    getCreationInput(
      "ratingInput",
      "First Completed Rating",
      "ratings",
      "Choose the first rating for when the box is in completed",
      true,
      {
        field: ["completed", "first"],
        name: newBoxType.ratings.completed.first.name,
        hint: newBoxType.ratings.completed.first.hint,
        icon: newBoxType.ratings.completed.first.icon,
      }
    ),
    getCreationInput(
      "ratingInput",
      "Second Completed Rating",
      "ratings",
      "Choose the second rating for when the box is in completed",
      true,
      {
        field: ["completed", "second"],
        name: newBoxType.ratings.completed.second.name,
        hint: newBoxType.ratings.completed.second.hint,
        icon: newBoxType.ratings.completed.second.icon,
      }
    ),
    getCreationInput(
      "pickRelatedTypes",
      "Pick Related Box Types",
      "related",
      "Pick BoxTypes that are related to this Type",
      false,
      {
        selected: newBoxType.related.types,
        descriptions: newBoxType.related.descriptions,
      }
    ),
    getCreationInput(
      "useTime",
      "Use Time Value",
      "time",
      "Select if your Box Type tracks some sort of time value",
      false,
      {
        time: newBoxType.time,
      }
    ),
    getCreationInput(
      "input",
      "Short Description hint",
      "shortDescription",
      "What hint for the short description should be displayed when creating this type",
      true,
      {
        value: newBoxType.descriptions.shortDescription,
        maxLength: 200,
        minLength: 4,
        inputType: "text",
        allowSpaces: true,
        fields: ["descriptions", "shortDescription"],
      }
    ),
    getCreationInput(
      "input",
      "Long Description Hint",
      "longDescription",
      "What hint for the long description should be displayed when creating this type",
      true,
      {
        value: newBoxType.descriptions.longDescription,
        maxLength: 200,
        minLength: 4,
        inputType: "text",
        fixed: false,
        allowSpaces: true,
        fields: ["descriptions", "longDescription"],
      }
    ),
    getCreationInput(
      "input",
      "Image Hint",
      "image",
      "What hint for the image should be displayed when creating this type",
      true,
      {
        value: newBoxType.descriptions.image,
        maxLength: 200,
        minLength: 4,
        inputType: "text",
        fixed: false,
        allowSpaces: true,
        fields: ["descriptions", "image"],
      }
    ),
    getCreationInput(
      "input",
      "Categories Hint",
      "categories",
      "What hint for the categories should be displayed when creating this type",
      true,
      {
        value: newBoxType.descriptions.categories,
        maxLength: 200,
        minLength: 4,
        inputType: "text",
        fixed: false,
        allowSpaces: true,
        fields: ["descriptions", "categories"],
      }
    ),
    getCreationInput(
      "input",
      "Keywords Hint",
      "keywords",
      "What hint for the keywords should be displayed when creating this type",
      true,
      {
        value: newBoxType.descriptions.keywords,
        maxLength: 200,
        minLength: 4,
        inputType: "text",
        fixed: false,
        allowSpaces: true,
        fields: ["descriptions", "keywords"],
      }
    ),
    getCreationInput(
      "input",
      "Things hint",
      "things",
      "What hint for the things should be displayed when creating this type",
      true,
      {
        value: newBoxType.descriptions.things,
        maxLength: 200,
        minLength: 4,
        inputType: "text",
        fixed: false,
        allowSpaces: true,
        fields: ["descriptions", "things"],
      }
    ),
    getCreationInput(
      "input",
      "Completed",
      "completed",
      "What is it called when the Box is marked as completed",
      true,
      {
        value: newBoxType.completed,
        maxLength: 200,
        minLength: 4,
        inputType: "text",
        fixed: false,
        allowSpaces: true,
      }
    ),
    getCreationInput(
      "checkbox",
      "Takes Points",
      "points",
      "Does this box accept points and trophies",
      false,
      {
        text: "Box Type accepts points and trophies",
        points: newBoxType.points,
      }
    ),
  ];
};

export default boxTypeInputs;
